/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable array-callback-return */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
//import InfiniteScroll from 'react-infinite-scroll-component';
import MyZzimItem from '../../components/my/MyZzimItem';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

class MyDownNew1 extends Component {
  state = {
    gotoPage: 1,
    pageCount: 1,
    pageSize: 20,
    dataList: [],
    allSelect: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async (gotoPage) => {
    const { loginId, pkg } = this.props;

    if (
      loginId === null ||
      loginId === undefined ||
      loginId === '' ||
      pkg === null ||
      pkg === undefined ||
      pkg === ''
    ) {
    } else {
      const result = await this._getDataApi(gotoPage);
      if (result) {
        const intReturn = result.data[0].intReturn;
        const pageCount = result.data[0].pageCount;
        const con = result.data[0].con;
        const dataList = result.data[0].listData;
        //console.log(con)
        if (this._isMounted) {
          if (intReturn === 0) {
            if (con > 0) {
              //console.log('con > 0')
              this.setState({
                gotoPage: gotoPage,
                con: con,
                pageCount: pageCount,
                dataList: dataList,
                hasMore: pageCount < gotoPage ? false : true,
              });
            } else {
              //console.log('con < 0')
              this.setState({
                gotoPage: 1,
                con: con,
                searchList: dataList,
                hasMore: pageCount < gotoPage ? false : true,
              });
            }
          } else {
            //console.log('intReturn <> 0')
            this.setState({
              gotoPage: 1,
              con: con,
              dataList: [],
              hasMore: pageCount < gotoPage ? false : true,
            });
          }
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId, authId, pkg, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    //console.log(loginId,)
    return axios
      .post(
        apiUrl + '/myDownList_pkg',
        {
          params: {
            userid: loginId,
            authId: authId,
            gotoPage: gotoPage,
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  _renderItem = () => {
    const { dataList } = this.state;
    const list = dataList.map((item, index) => {
      return (
        <MyZzimItem
          key={index}
          index={index}
          contentSerial={item.contentSerial}
          title={item.title}
          img={item.img}
          genreName={item.genreName}
          sameCode={item.sameCode}
          restrictionCode={item.restrictionCode}
          selected={item.selected}
          director={item.director}
          contentSysnopsis={item.contentSysnopsis}
          wishFlag={item.wishFlag}
          contentPartSerial={item.contentPartSerial}
          _selected={this._selected}
          pos={'view'}
        />
      );
    });

    return list;
  };

  /*
    _onAllDelete = () => {
        const { dataList } = this.state;
        if(dataList.length <= 0) {
            toast.warn('삭제할 작품이 존재하지 안습니다.')
            return; 
        } 

        confirmAlert({ 
            title: '찜하기 전체 삭제',
            message: '찜해놓은 모든 작품을 삭제하시겠습니까? 삭제된 데이터는 복구 되지 않습니다.',
            buttons: [
              
              {
                label: '모두 삭제',
                onClick: async () => {
                    const result = await this._onAllDeleteApi();
                    const intReturn = result.data[0].intReturn;

                    if(intReturn === 0) {
                        toast.success('찜한 작품이 모두 삭제 되었습니다.');
                        this._getData(1)
                    } else {
                        toast.warn('삭제할 작품이 존재하지 안습니다.')
                    }
                }
              },
              
              {
                label: '취소',
                //onClick: () => alert('Click No')
              }
            ]
        });
    }
    _onAllDeleteApi = () => {
        const { apiUrl, loginId, dataList, authId } = this.props; 
    
        return axios.post(apiUrl + '/myZzimAllDel', {
            params: {
                userid: loginId,
                authId: authId
            }
        }) 
        .then(response => response)
        .catch(error => {
            alert('오류가 발생했습니다.')
        })
    }
    */

  _renderPage = () => {
    const { gotoPage, con, pageCount } = this.state;

    const dataPerPage = isMobile ? 5 : 10; //한페이지에 보여질 갯수

    let pageCount1;

    if (pageCount > dataPerPage) {
      pageCount1 = dataPerPage;
    } else {
      pageCount1 = pageCount;
    }
    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수

    const pageGroup = Math.ceil(gotoPage / pageCount1); //페이지 그룹
    let last = pageGroup * pageCount1;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount1 - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount1) {
    } else {
    }

    if (next > pageCount1 && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }

    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => this._getData(num)}
          className={gotoPage === num ? 'on' : null}
        >
          {num}
        </span>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return (
      <Fragment>
        {first > pageCount1 ? (
          <span onClick={this._onPrev}>이전</span>
        ) : (
          <span style={{ backgroundColor: '#000' }}></span>
        )}
        {list}
        {next > pageCount1 && next < totalPage ? (
          <span onClick={this._onNext}>다음</span>
        ) : (
          <span style={{ backgroundColor: '#000' }}></span>
        )}
      </Fragment>
    );
  };

  _onPrev = () => {
    const { gotoPage } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn('페이지의 처음입니다.');
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 >= pageCount) {
      toast.warn('페이지의 마지막입니다.');
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };

  _allSelect = () => {
    const { allSelect, dataList } = this.state;

    dataList.map((item, index) => {
      if (!allSelect) {
        item.selected = item.contentSerial;
      } else {
        item.selected = 0;
      }
    });

    this.setState({
      allSelect: !allSelect,
    });
  };

  _selected = (index, contentSerial) => {
    const { dataList } = this.state;

    if (dataList[index].selected === 0) {
      dataList[index].selected = contentSerial;
    } else {
      dataList[index].selected = 0;
    }

    this.setState({
      dataList,
    });
  };

  _del = async () => {
    // const { loginId } = this.props;
    const { dataList, gotoPage } = this.state;

    let delList = [];

    dataList.find((item, index) => {
      if (item.selected !== 0) {
        delList.push(item.selected);
      }
    });
    //console.log(delList)
    if (delList.length <= 0) {
      toast.warn('삭제할 작품이 존재하지 않습니다.');
    } else {
      let stringCode = '';

      delList.map((item, index) => {
        stringCode = stringCode + item + '|';
      });

      const result = await this._delApi(stringCode);
      if (result) {
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          this._getData(gotoPage);
        }
      }
    }
  };

  _delApi = (stringCode) => {
    const { apiUrl, loginId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/myDownDel',
        {
          params: {
            userid: loginId,
            stringCode: stringCode,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(1);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
        //console.log('error...')
      });
  };
  _refreshToken = async (part) => {
    const { gotoPage } = this.state;
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (part === 0) {
        this._getData(gotoPage);
      } else if (part === 1) {
        this._del();
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };

  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  render() {
    // const { tabIndex } = this.props.childProps;
    const { dataList, con, allSelect } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="list_wrap">
          <div className="listHead">
            <span className="total">
              총 <em>{con}</em>개
            </span>

            <div className="fl_rt">
              <button type="button" className="btn_del" onClick={this._del}>
                선택삭제
              </button>
              <input
                type="checkbox"
                className="chkBox"
                name="chk"
                id="chkAll"
                checked={allSelect}
                onChange={this._allSelect}
              />
              <label htmlFor="chkAll" className="chk"></label>
            </div>
          </div>
          <div className="list">
            {dataList ? (
              this._renderItem()
            ) : (
              <ul>
                <li className="thumb">
                  <img src={imgUrl + '/img/test_img1.png'} />
                </li>
                <li className="info">
                  <p className="subject"></p>
                  <p className="detail">
                    <span></span>
                    <span></span>
                    <span></span>
                  </p>
                  <div className="story"></div>
                </li>
                {/*<input type="checkbox" className="chkBox" name="chk" id="chk1"/><label htmlFor="chk1" className="chk"></label>*/}
              </ul>
            )}
          </div>
          <div className="page_no">{dataList ? this._renderPage() : null}</div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(MyDownNew1)));
